import React, { memo } from 'react'

import { InformationFilled32 } from '@carbon/icons-react'
import { Button } from '@ublique/components'

const InfoButton = ({ message, alignment = 'end' }) => {
  return (
    <Button
      hasIconOnly
      className='info-button'
      renderIcon={InformationFilled32}
      iconDescription={message}
      tooltipPosition='bottom'
      tooltipAlignment={alignment}
    />
  )
}

export default memo(InfoButton)
